export class VariantService {
  public variants = [];
  public totalCount = 0;
  public perPageCount = 15;
  public currentPage = 1;
  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Catalogues.VariantResponse | InterACT.Interfaces.Catalogues.VariantsResponse>>;

  constructor($resource) {
    this.resource = $resource('api/catalogues/:catalogueId/products/:productId/variants/:variantId', undefined, { edit: { method: 'PATCH' }, update: { method: 'PUT' } });
  }

  public create(catalogueId: string, productId: number, data: any) {
    this.deleteUnusedFields(data);

    const options = {
      catalogueId: catalogueId,
      productId: productId
    };

    return this.resource.save(options, data).$promise.then(() => {
      return this.getList(catalogueId, productId);
    });
  }

  public edit(catalogueId: string, productId: number, variantId: number, data) {
    const options = {
      catalogueId: catalogueId,
      productId: productId,
      variantId: variantId
    };
    return (<any>this.resource).edit(options, data).$promise;
  }

  public getVariant(catalogueId: string, productId: number, variantId: number, catalogueVersion?: number) {
    const options = {
      catalogueId: catalogueId,
      productId: productId,
      variantId: variantId,
      catalogueVersion: catalogueVersion
    };
    return this.resource.get(options).$promise.then((resource: InterACT.Interfaces.Catalogues.VariantResponse) => {
      return resource.variant;
    });
  }

  public update(catalogueId: string, productId: number, variantId: number, data) {
    this.deleteUnusedFields(data);

    const options = {
      catalogueId: catalogueId,
      productId: productId,
      variantId: variantId
    };
    return (<any>this.resource).update(options, data).$promise;
  }

  public getList(catalogueId: string, productId: number, page?: number, perPageCount?: number, options?: any) {
    let baseOptions;

    if (angular.isDefined(page)) {
      this.currentPage = page;
    } else {
      this.currentPage = 1;
    }

    if (angular.isDefined(perPageCount)) {
      this.perPageCount = perPageCount;
    }

    baseOptions = {
      expand: false,
      page: this.currentPage,
      offset: (this.currentPage - 1) * this.perPageCount,
      limit: this.perPageCount,
      catalogueId: catalogueId,
      productId: productId
    };

    return this.resource.get(_.merge(baseOptions, options)).$promise.then((resource: InterACT.Interfaces.Catalogues.VariantsResponse) => {
      this.variants = resource.variants;
      this.totalCount = resource.meta.totalCount;
      return resource;
    });
  }

  public getListAfterUpdate(catalogueId: string, productId: number) {
    if (this.variants.length === 0) {
      if (this.currentPage > 1) {
        return this.getList(catalogueId, productId, this.currentPage - 1, this.perPageCount);
      }
    } else {
      return this.getList(catalogueId, productId, this.currentPage, this.perPageCount);
    }
  }

  public remove(catalogueId: string, productId: number, variantId: number) {
    const options = {
      catalogueId: catalogueId,
      productId: productId,
      variantId: variantId
    };

    return this.resource.delete(options).$promise.then(() => {
      return this.getListAfterUpdate(catalogueId, productId);
    });
  }

  private deleteUnusedFields(data: InterACT.Interfaces.Catalogues.Variant) {
    if (data.hasOwnProperty('type')) {
      delete data['type'];
    }

    ["operator","service","zones","entitlements"].forEach(element => {
      if (data.fields[element] && Array.isArray(data.fields[element])) {
        data.fields[element] = data.fields[element].filter((entry:any) => entry.link);
  
        if (data.fields[element].length === 0) {
          delete data.fields[element];
        }
      }
    });

  }
}
